import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "empty-state flex flex-col items-center justify-center h-full"
}
const _hoisted_2 = { class: "text-gray-600 text-center max-w-md" }
const _hoisted_3 = {
  key: 1,
  class: "message-list space-y-6"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChatbotMessage = _resolveComponent("ChatbotMessage")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "chatbot-messages overflow-y-auto px-5 py-4 bg-gray-50 transition-all duration-300",
      ref: "messagesContainer",
      onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
    }, [
      (!_ctx.messages || _ctx.messages.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "bg-blue-100 rounded-full p-4 mb-4" }, [
              _createElementVNode("svg", {
                class: "h-8 w-8 text-blue-600",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
                })
              ])
            ], -1)),
            _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "text-lg font-medium text-gray-900 mb-2" }, "Welcome to Fraport Assistant!", -1)),
            _createElementVNode("p", _hoisted_2, " Hello " + _toDisplayString(_ctx.userData?.name || 'there') + "! I'm here to help you with your airport management tasks. Feel free to ask me anything. ", 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message) => {
              return (_openBlock(), _createBlock(_component_ChatbotMessage, {
                key: message.id,
                message: message,
                isUser: !message.is_ai_message,
                userAvatar: _ctx.userData?.avatar,
                userName: _ctx.userData?.name
              }, null, 8, ["message", "isUser", "userAvatar", "userName"]))
            }), 128))
          ]))
    ], 544),
    (_ctx.showScrollButton)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.scrollToBottom && _ctx.scrollToBottom(...args))),
          class: "scroll-to-bottom-button fixed bg-blue-300 text-white rounded-full p-3 shadow-lg hover:bg-blue-500 transition-all duration-300 z-10",
          style: {"position":"absolute","bottom":"2rem","left":"50%"},
          "aria-label": "Scroll to bottom"
        }, _cache[4] || (_cache[4] = [
          _createElementVNode("svg", {
            class: "h-5 w-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M19 14l-7 7m0 0l-7-7m7 7V3"
            })
          ], -1)
        ])))
      : _createCommentVNode("", true)
  ], 64))
}